import { Link } from "react-router-dom";
import { Linkedin, Youtube, Twitter } from "lucide-react";
import { LOGO_SRC } from "./Logo";

export const Footer = () => {
  return (
    <footer className="bg-white border-t border-[#E5E7EB]">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 grid grid-cols-1 md:grid-cols-3 gap-12">
        <div>
          <img src={LOGO_SRC} alt="SCMBrain" className="h-[30px] w-auto mb-4" />
          <p className="text-sm text-[#3E577A] leading-relaxed max-w-xs">
            Supply Chain Intelligence — videos, frameworks, assessments, and tools built by
            practitioners, for practitioners.
          </p>
        </div>

        <div>
          <h4 className="font-heading font-bold text-sm uppercase tracking-[0.15em] text-[#1B3A6B] mb-4">
            Explore
          </h4>
          <ul className="space-y-3 text-sm text-[#3E577A]">
            <li><Link to="/videos" className="hover:text-[#1A6B5A]">Videos</Link></li>
            <li><Link to="/insights" className="hover:text-[#1A6B5A]">Insights</Link></li>
            <li><Link to="/tools" className="hover:text-[#1A6B5A]">Tools</Link></li>
            <li><Link to="/newsletter" className="hover:text-[#1A6B5A]">Newsletter</Link></li>
            <li><Link to="/about" className="hover:text-[#1A6B5A]">About</Link></li>
            <li><Link to="/about" className="hover:text-[#1A6B5A]">Contact</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="font-heading font-bold text-sm uppercase tracking-[0.15em] text-[#1B3A6B] mb-4">
            Legal
          </h4>
          <ul className="space-y-3 text-sm text-[#3E577A]">
            <li><Link to="/terms" className="hover:text-[#1A6B5A]">Terms of Use</Link></li>
            <li><Link to="/privacy" className="hover:text-[#1A6B5A]">Privacy Policy</Link></li>
            <li><Link to="/disclaimer" className="hover:text-[#1A6B5A]">Disclaimer</Link></li>
          </ul>
          <div className="flex items-center gap-4 mt-6">
            <a href="https://linkedin.com" aria-label="LinkedIn" className="text-[#3E577A] hover:text-[#1A6B5A]"><Linkedin className="h-5 w-5" /></a>
            <a href="https://youtube.com" aria-label="YouTube" className="text-[#3E577A] hover:text-[#1A6B5A]"><Youtube className="h-5 w-5" /></a>
            <a href="https://twitter.com" aria-label="Twitter" className="text-[#3E577A] hover:text-[#1A6B5A]"><Twitter className="h-5 w-5" /></a>
          </div>
        </div>
      </div>

      <div className="border-t border-[#E5E7EB]">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-6 text-xs text-[#3E577A]">
          © 2026 SCMBrain. All rights reserved.
        </div>
      </div>
    </footer>
  );
};

export default Footer;
